import { activityTypes, type ActivityType } from 'types';

export function isActivityType(value: string | undefined): value is ActivityType {
  return value !== undefined && activityTypes.includes(value as ActivityType);
}

/**
 * Resolve a URL activity type against the optional type owned by the outlet or
 * service category.
 * A null result is an invalid or cross-type route and must not render a list.
 */
export function resolveProductRouteType(
  outletOrServiceCategoryType: ActivityType | null,
  routeType: string | undefined,
): ActivityType | null {
  if (!isActivityType(routeType)) return null;
  if (outletOrServiceCategoryType !== null && outletOrServiceCategoryType !== routeType) return null;
  return routeType;
}
